document.addEventListener('alpine:init', () => {
  Alpine.data('bundle', () => ({
    posters: [{}, {}, {}],
    activeIndex: null,
    maxPosterCount: 4,
    minPosterCount: 3,
    observer: null,
    atcText:'Wähle dein erstes Design',
    selectedFrame: 'none',
    bundleProgress: {
      justSelected: "",
      msg: "Great Choice, Add The Next Poster."
    },

    get validPosters() {
      return this.posters.filter(p => p.name && p.handle);
    },

    get selectedCount() {
      return this.validPosters.length;
    },

    openBundleDrawer(index) {
      this.activeIndex = index;
      this.$root.querySelector('.bundle-trigger')?.click();
    },
    fillPosters() {

      switch (this.selectedCount) {
        case 0:
          this.atcText = 'Wähle dein erstes Design'
          this.bundleProgress.msg = 'Gute Wahl, wähle dein nächstes Poster aus.'
          break;
        case 1:
          this.atcText = 'Wähle dein zweites Design'
          this.bundleProgress.msg = 'Gute Wahl, wähle dein nächstes Poster aus.'
          break;
        case 2:
          this.atcText = 'Wähle dein drittes Design'
          this.bundleProgress.msg = 'Gute Wahl, wähle dein nächstes Poster aus.'
          break;
        case 3:
          this.atcText = 'In den Warenkorb'
          this.bundleProgress.msg = 'Gute Wahl, dein Bundle ist vollständig. Füge noch ein Design hinzu und spare noch mehr!'
          break;
        case 4:
          this.atcText = 'In den Warenkorb'
          this.bundleProgress.msg = 'Gute Wahl, dein Bundle ist vollständig.'
          break;
        default:
          break;
      }


      if (this.selectedCount >= this.minPosterCount  && this.posters.length == this.selectedCount && this.posters.length < this.maxPosterCount) {
        this.posters.push({})
      } 
      while (this.posters.length > this.minPosterCount && this.posters.length > this.selectedCount + 1 && !this.posters.at(-1)?.handle) {
        this.posters.pop();
      }
    },

    renderBundlePicker(target) {
      if (this.activeIndex === null) return;

      const { name, handle } = target.dataset;
      const src = target.getAttribute('src');
      const index = this.activeIndex;

      this.posters[index] = { name, handle, src };
      this.bundleProgress.justSelected = name;

      this.fillPosters();

      this.$root.querySelector('.bundle-container .mobile-facets__close')?.click();
      this.activeIndex = null;



      this.updateButtonState();
      this.triggerChange();
    },

    removeBundlePicker(index) {
      this.posters[index] = {};
      this.fillPosters();
      this.updateButtonState();
      this.triggerChange();
    },

    updateButtonState() {
      const btn = this.$root.querySelector('.product-form__submit');
      if (!btn) return;

      const shouldDisable = this.selectedCount < this.minPosterCount;
      btn.disabled = shouldDisable;
      btn.classList.toggle('bundle-disabled', shouldDisable);
    },

    triggerChange() {
      const targetCount = Math.max(this.selectedCount, this.minPosterCount);
      const input = this.$root.querySelector(`input[name="Anzahl"][value="${targetCount}"]`);

      if (input) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        console.log(`Count option set to ${targetCount}`);
      } else {
        console.warn(`Count value ${targetCount} not found`);
      }
    },

    watchButtonState() {
      const btn = this.$root.querySelector('.product-form__submit');
      if (!btn) return;

      if (this.observer) this.observer.disconnect(); // 避免重复观察
      this.observer = new MutationObserver(() => {
        const shouldDisable = this.selectedCount < this.minPosterCount;
        if (shouldDisable && !btn.disabled) {
          btn.disabled = true;
          btn.classList.add('bundle-disabled');
        }
      });

      this.observer.observe(btn, {
        attributes: true,
        attributeFilter: ['disabled', 'class']
      });
    },

    init() {
      this.updateButtonState();
      this.watchButtonState();
      this.triggerChange();

      // 初始化选中的画框颜色
      this.selectedFrame = this.$root.querySelector('input[name=Farbe]:checked')?.value || '';

      this.$root.querySelectorAll('input[name=Farbe]').forEach(radio => {
        radio.addEventListener('change', e => {
          this.selectedFrame = e.target.value;
        });
      });

      // 初始化所有可选图片
      this.$root.querySelectorAll('.products-container .image-picker').forEach(img => {
        img.addEventListener('click', e => {
          this.renderBundlePicker(e.currentTarget);
        });
      });
    },

    destroy() {
      if (this.observer) this.observer.disconnect();
    }
  }));
});
